import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

export const ConfirmAction = ({ trigger, title, description, confirmLabel = "Delete", onConfirm, testId }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
    <AlertDialogContent className="bg-[#121212] border-[#2A2A2A] rounded-none">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display text-2xl text-ivory">{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testId}-cancel`}>Keep</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} data-testid={`${testId}-confirm`} className="bg-[#4A1C1C] text-ivory hover:bg-[#5a2222]">{confirmLabel}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
